import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { SharedModule }                          from '../shared/shared.module';
import { TableModule }                           from '../table/table.module';
import { TillpaymentsActivatePosComponent }      from './tillpayments.activate-pos.component';
import { TillpaymentsOnlineSettingsComponent   } from './tillpayments.online-settings.component';
import { TillpaymentsPosSettingsComponent }      from './tillpayments.pos-settings.component';
import { TillpaymentsService }                   from './tillpayments.service';
import { TillpaymentsSettingsComponent }         from './tillpayments.settings.component';
import { TillpaymentsStates }                    from './tillpayments.states';
import { TillpaymentsTerminalsComponent }        from './tillpayments.terminals.component';
import { TillpaymentsTransactionComponent }      from './tillpayments.transaction.component';

@NgModule({
  declarations: [
    TillpaymentsActivatePosComponent,
    TillpaymentsOnlineSettingsComponent,
    TillpaymentsSettingsComponent,
    TillpaymentsPosSettingsComponent,
    TillpaymentsTerminalsComponent,
    TillpaymentsTransactionComponent
  ],
  entryComponents: [
    TillpaymentsActivatePosComponent,
    TillpaymentsTerminalsComponent,
    TillpaymentsTransactionComponent
  ],
  imports: [
    SharedModule,
    TableModule,
    UIRouterModule.forChild({ states: TillpaymentsStates })
  ],
  providers: [
    TillpaymentsService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class TillpaymentsModule {}
